// style import
import styles from './linkComponent.module.scss';

// component import
import LinkItem from './_LinkItem';

// type import
import { LinkProps } from '@lib/types';

/**
 * Link component, used to render links 1 or 2 links
 *
 * @param props - The component props object
 * @param props.link1 - First LinkProps to render
 * @param props.link2 - Optional - Second LinkProps to render
 * @returns individual link, or double link container
 *
 * @example Basic single link
 * ```tsx
 * <LinkComponent link1={{text: 'Link', url: '/link'}} />
 * ```
 *
 * @example Double link container
 * ```tsx
 * <LinkComponent
 *      link1={{text: 'Link 1', url: '/link1'}}
 *      link2={{text: 'Link 2', url: '/link2'}}
 * />
 * ```
 *
 * @example Link with onClick and target
 * ```tsx
 * <LinkComponent
 *  link1={{
 *      text: 'Link',
 *      url: '/link',
 *      onClick: () => console.log('clicked'),
 *      target: '_blank'
 * }}
 * />
 * ```
 */
const LinkComponent = ({
    link1,
    link2,
}: {
    link1: LinkProps;
    link2?: LinkProps;
}) => {
    // If one link is passed, render only single link
    if (!link2) return <LinkItem {...link1} />;

    // If two links are passed, render double link container with line separator
    return (
        <div className={styles.doublelinkcontainer}>
            <LinkItem {...link1} />
            <hr className={styles.hr} />
            <LinkItem {...link2} />
        </div>
    );
};

export default LinkComponent;
